import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'convfact-promotion-included-dialog',
    templateUrl: './promotion-included-dialog.component.html',
    styleUrls: ['./promotion-included-dialog.component.css'],
    standalone: false
})
export class PromotionIncludedDialogComponent {

  moduleName: string = '';
  actionLabel: string = 'Entendido';
  isConfirm: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PromotionIncludedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.moduleName = data && data.moduleName ? data.moduleName : 'Módulo';
    this.actionLabel = data && data.actionLabel ? data.actionLabel : 'Entendido';
    this.isConfirm = !!(data && data.isConfirm);
  }

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
